import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { usePSNavigate } from '../../../hooks/usePSNavigate'
import Heading from '../../app/design/Heading'
import Paragraph from '../../app/design/Paragraph'
import { SelectPlanPage } from '../../settings/SelectPlanPage'

export function AlertAffiliatePage() {
    const queryClient = useQueryClient()
    const navigate = usePSNavigate()

    const onNext = useCallback(async () => {
        await queryClient.invalidateQueries({ queryKey: ['dashboard'] })
        navigate('/')
    }, [navigate, queryClient])

    return (
        <div className="mx-auto mt-7 max-w-[648px]">
            <Heading size="md" className="mb-4 text-center">
                Thanks for finding us through an affiliate
            </Heading>
            <Paragraph size="md" className="mb-12 text-center text-gray-600">
                For a limited time, you are entitled to a special offer on an annual plan
            </Paragraph>
            <SelectPlanPage context="affiliate" showHeader={false} onNext={onNext} />
        </div>
    )
}
